<div class="card shadow">
  <div class="card-body">
    <app-table-header-template [searchOptions]="EmployeeSearchOptions">
      <ng-container filter>
        <app-employees-filter (query)="update($event)"></app-employees-filter>
      </ng-container>
      <ng-container buttons>
        <button
          id="addEmployeeButton"
          (click)="onAddEmployee()"
          class="btn btn-primary btn-sm">
          Add
        </button>
      </ng-container>
    </app-table-header-template>

    <app-table
      [columns]="columns"
      [getDataCallback]="getData">
      <ng-template
        #employeeNameCell
        let-row="row"
        let-value="value">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-0">
            <app-avatar
              [firstName]="row.first_name"
              [lastName]="row.last_name"></app-avatar>
          </div>
          <div class="col ps-2">
            {{ value }}<br />
            @if (row.role.toLowerCase() === 'admin') {
              <div class="badge bg-dark">ADMIN</div>
            }
          </div>
          <div class="col-auto ms-auto">
            @if (!row?.email_verified || !row?.phone_verified || row?.contact_change_pending) {
              <div
                class="warning-icon"
                [ngbTooltip]="tipContent">
                <i class="iconoir-warning-circle"></i>
              </div>
            }
            <ng-template #tipContent>
              @if (!row?.email_verified) {
                We are waiting on the updated email to be verified.
              }
              @if (!row?.phone_verified) {
                We are waiting on the updated phone number to be verified.
              }
              @if (row?.contact_change_pending) {
                We are waiting on the updated contact details to be verified.
              }
            </ng-template>
          </div>
        </div>
      </ng-template>

      <ng-template
        #dateCreatedCell
        let-value="value">
        {{ value | date: 'dd/MM/yy' }}
      </ng-template>

      <ng-template
        #kycStatusCell
        let-row="row">
        @if (row.is_subscription_card_holder || row.is_card_holder) {
          <app-status-badge
            [value]="row.idnum_status"
            [department]="statusBadgeDepartments.ID_VERIFICATION"></app-status-badge>
        } @else {
          -
        }
      </ng-template>

      <ng-template
        #actionsCell
        let-row="row">
        <div class="row">
          <div class="col-auto">
            <button
              class="btn-action"
              (click)="onRemoveEmployee(row)"
              (keyup.enter)="onRemoveEmployee(row)"
              title="Remove Employee">
              <i class="pays-icon ic-bin"></i>
            </button>
          </div>
          <div class="col-auto">
            <button
              (click)="onViewEmployee(row.id)"
              class="btn-action">
              <i class="iconoir-nav-arrow-right"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
